(function(){
'use strict';
var allStores=[],filtered=[],showing=0,PAGE_SIZE=24,currentFilter='all',searchQuery='',map=null,userMarker=null,markers=[],mapLoaded=false;
var CORKY_FALLBACK='https://www.corkyscoffee.com/cdn/shop/files/CORKY_Logo.png?v=1765253829';

function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function tc(s){return String(s).replace(/\w\S*/g,function(w){return w.charAt(0).toUpperCase()+w.slice(1);});}

function waitForData(cb){
  var checks=0;
  (function poll(){
    var rsd=window.__RSD_DATA,csd=window.__CSD_DATA;
    if(rsd&&csd){cb(rsd,csd);return;}
    if(++checks>200){if(rsd||csd)cb(rsd||[],csd||[]);return;}
    setTimeout(poll,100);
  })();
}

function buildStores(rsd,csd){
  for(var i=0;i<rsd.length;i++){
    var s=rsd[i];
    allStores.push({type:'vinyl',h:s[0],n:s[1],c:(s[2]||'').toLowerCase(),st:(s[3]||'').toLowerCase(),co:(s[4]||'').toLowerCase(),img:s[8]||s[7]||'',url:'/pages/record-store/'+s[0]});
  }
  for(var j=0;j<csd.length;j++){
    var c=csd[j];
    allStores.push({type:'coffee',h:c[0],n:c[1],c:(c[2]||'').toLowerCase(),st:(c[3]||'').toLowerCase(),co:(c[4]||'').toLowerCase(),img:c[12]||c[11]||'',url:'/pages/coffee-shop/'+c[0]});
  }
  for(var k=allStores.length-1;k>0;k--){var r=Math.floor(Math.random()*(k+1)),t=allStores[k];allStores[k]=allStores[r];allStores[r]=t;}
  updateStats(rsd.length,csd.length);
  applyFilters();
}

function updateStats(vc,cc){
  var total=vc+cc;
  var states={};allStores.forEach(function(s){if(s.st)states[s.st]=1;if(s.co&&s.co!=='us'&&s.co!=='united states')states[s.co]=1;});
  var e1=document.getElementById('ecw-stat-total'),e2=document.getElementById('ecw-stat-vinyl'),e3=document.getElementById('ecw-stat-coffee'),e4=document.getElementById('ecw-stat-regions');
  if(e1)e1.textContent=total.toLocaleString();if(e2)e2.textContent=vc.toLocaleString();if(e3)e3.textContent=cc.toLocaleString();if(e4)e4.textContent=Object.keys(states).length;
}

function applyFilters(){
  var q=searchQuery.toLowerCase().trim();
  filtered=allStores.filter(function(s){
    if(currentFilter!=='all'&&s.type!==currentFilter)return false;
    if(q){if(s.n.toLowerCase().indexOf(q)<0&&s.c.indexOf(q)<0&&s.st.indexOf(q)<0&&s.co.indexOf(q)<0)return false;}
    return true;
  });
  showing=0;
  var grid=document.getElementById('ecw-grid');if(grid)grid.innerHTML='';
  renderGrid();
  updateCount();
  if(mapLoaded)updateMapMarkers();
}

function updateCount(){
  var el=document.getElementById('ecw-count');
  if(el)el.textContent=filtered.length.toLocaleString()+' '+(currentFilter==='all'?'stores':currentFilter==='vinyl'?'record stores':'coffee shops')+' found';
}

function renderGrid(){
  var grid=document.getElementById('ecw-grid');if(!grid)return;
  var batch=filtered.slice(showing,showing+PAGE_SIZE);
  batch.forEach(function(s){
    var card=document.createElement('a');
    card.className='ecw-card';
    card.href=s.url;
    var city=tc(s.c),state=s.st?s.st.toUpperCase():tc(s.co),loc=state?city+', '+state:city;
    var badgeClass=s.type==='vinyl'?'ecw-card__badge--vinyl':'ecw-card__badge--coffee';
    var badgeText=s.type==='vinyl'?'Vinyl':'Coffee';
    var hasImg=s.img&&/\.(jpg|png|webp|photo|googleapis)|cdn\.shopify/.test(s.img);
    var imgSrc=hasImg?esc(s.img):CORKY_FALLBACK;
    var imgClass=hasImg?'':'ecw-card__img--fallback';
    card.innerHTML='<div class="ecw-card__img '+imgClass+'"><img src="'+imgSrc+'" alt="" loading="lazy" onerror="this.onerror=null;this.src=\''+CORKY_FALLBACK+'\';this.parentElement.classList.add(\'ecw-card__img--fallback\')"><span class="ecw-card__badge '+badgeClass+'">'+badgeText+'</span></div>'
      +'<div class="ecw-card__body"><span class="ecw-card__name">'+esc(s.n)+'</span><span class="ecw-card__loc"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>'+esc(loc)+'</span></div>';
    grid.appendChild(card);
  });
  showing+=batch.length;
  var btn=document.getElementById('ecw-load-more');
  if(btn)btn.style.display=showing<filtered.length?'block':'none';
}

function initMap(){
  var el=document.getElementById('ecw-map');
  if(!el||typeof L==='undefined')return;
  map=L.map('ecw-map',{zoomControl:false,attributionControl:false,scrollWheelZoom:false}).setView([39.8,-98.5],4);
  L.control.zoom({position:'bottomright'}).addTo(map);
  L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',{maxZoom:19,subdomains:'abcd'}).addTo(map);
  el.addEventListener('mouseenter',function(){map.scrollWheelZoom.enable()});
  el.addEventListener('mouseleave',function(){map.scrollWheelZoom.disable()});
  updateMapMarkers();
}

function updateMapMarkers(){
  if(!map||!allStores.length)return;
  if(markers.length){markers.forEach(function(m){map.removeLayer(m)});markers=[];}
  var coords=window.__CITY_COORDS||{};
  var cityData={};
  allStores.forEach(function(s){
    var key=(s.c+'_'+s.st).toLowerCase();
    if(!cityData[key])cityData[key]={city:s.c,state:s.st,vinyl:0,coffee:0,total:0};
    if(s.type==='vinyl')cityData[key].vinyl++;
    else if(s.type==='coffee')cityData[key].coffee++;
    else{cityData[key].vinyl++;cityData[key].coffee++;}
    cityData[key].total++;
  });
  Object.keys(cityData).forEach(function(key){
    var c=coords[key];if(!c)return;
    var d=cityData[key];
    var isVinyl=d.vinyl>0&&d.coffee===0;
    var isCoffee=d.coffee>0&&d.vinyl===0;
    var color=isVinyl?'#7c5cfc':isCoffee?'#ff6b35':'#ffd166';
    var glow=isVinyl?'rgba(124,92,252,.6)':isCoffee?'rgba(255,107,53,.6)':'rgba(255,209,102,.6)';
    var sz=Math.min(14+Math.sqrt(d.total)*4,40);
    var html='<div class="ecw-glow-marker" style="width:'+sz+'px;height:'+sz+'px;background:'+color+';box-shadow:0 0 '+Math.round(sz*.6)+'px '+glow+',0 0 '+Math.round(sz*1.2)+'px '+glow+';border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:'+Math.round(sz*.4)+'px;font-weight:700;color:#fff;cursor:pointer;transition:transform .2s,box-shadow .2s;border:2px solid rgba(255,255,255,.3)">'+(d.total>1?d.total:'')+'</div>';
    var icon=L.divIcon({className:'ecw-marker-glow',html:html,iconSize:[sz,sz],iconAnchor:[sz/2,sz/2]});
    var mk=L.marker(c,{icon:icon});
    var cn=tc(d.city),sn=d.state?d.state.toUpperCase():'',loc=sn?cn+', '+sn:cn;
    var tip='<div style="font-family:Libre Franklin,sans-serif;text-align:center"><strong style="font-size:13px;color:#fff">'+esc(loc)+'</strong><div style="font-size:11px;color:rgba(255,255,255,.7);margin-top:3px">';
    if(d.vinyl>0)tip+='<span style="color:#7c5cfc">&#9679;</span> '+d.vinyl+' vinyl';
    if(d.vinyl>0&&d.coffee>0)tip+=' &middot; ';
    if(d.coffee>0)tip+='<span style="color:#ff6b35">&#9679;</span> '+d.coffee+' coffee';
    tip+='</div></div>';
    mk.bindTooltip(tip,{className:'ecw-dark-tooltip',direction:'top',offset:[0,-sz/2-4],opacity:1});
    mk.on('click',function(){var si=document.querySelector('.ecw-search__input');if(si){si.value=cn;si.dispatchEvent(new Event('input',{bubbles:true}));}map.flyTo(c,8,{duration:0.8});});
    mk.on('mouseover',function(){var e=this.getElement();if(e){var g=e.querySelector('.ecw-glow-marker');if(g){g.style.transform='scale(1.3)';g.style.boxShadow='0 0 '+Math.round(sz*.8)+'px '+glow+',0 0 '+Math.round(sz*1.6)+'px '+glow+',0 0 '+Math.round(sz*2.4)+'px '+glow;}}});
    mk.on('mouseout',function(){var e=this.getElement();if(e){var g=e.querySelector('.ecw-glow-marker');if(g){g.style.transform='scale(1)';g.style.boxShadow='0 0 '+Math.round(sz*.6)+'px '+glow+',0 0 '+Math.round(sz*1.2)+'px '+glow;}}});
    mk.addTo(map);markers.push(mk);
  });
}

function locateMe(){
  if(!map)return;
  var btn=document.getElementById('ecw-locate-btn');
  if(btn){btn.classList.add('ecw-locate--active');btn.querySelector('.ecw-locate__text').textContent='Locating...';}
  if(!navigator.geolocation){
    if(btn){btn.classList.remove('ecw-locate--active');btn.querySelector('.ecw-locate__text').textContent='Not supported';}
    setTimeout(function(){if(btn)btn.querySelector('.ecw-locate__text').textContent='Locate Me';},2000);
    return;
  }
  navigator.geolocation.getCurrentPosition(function(pos){
    var lat=pos.coords.latitude,lng=pos.coords.longitude;
    map.flyTo([lat,lng],8,{duration:1});
    if(userMarker){map.removeLayer(userMarker);}
    var icon=L.divIcon({className:'ecw-marker-glow',html:'<div class="ecw-user-marker"><div class="ecw-user-marker__dot"></div><div class="ecw-user-marker__ring"></div></div>',iconSize:[24,24],iconAnchor:[12,12]});
    userMarker=L.marker([lat,lng],{icon:icon,zIndex:9999}).addTo(map);
    userMarker.bindTooltip('<div style="font-family:Libre Franklin,sans-serif;text-align:center"><strong style="font-size:13px;color:#fff">You are here</strong></div>',{className:'ecw-dark-tooltip',direction:'top',offset:[0,-16],opacity:1});
    var coords=window.__CITY_COORDS||{};
    var nearest=null,nearDist=Infinity;
    Object.keys(coords).forEach(function(key){
      var c=coords[key];
      var d=Math.sqrt(Math.pow(lat-c[0],2)+Math.pow((lng-c[1])*Math.cos(lat*Math.PI/180),2))*111;
      if(d<nearDist){nearDist=d;nearest=key;}
    });
    if(nearest&&nearDist<200){
      var city=nearest.split('_')[0];
      var si=document.querySelector('.ecw-search__input');
      if(si){si.value=city.replace(/\w\S*/g,function(w){return w.charAt(0).toUpperCase()+w.slice(1)});si.dispatchEvent(new Event('input',{bubbles:true}));}
    }
    if(btn){btn.classList.remove('ecw-locate--active');btn.querySelector('.ecw-locate__text').textContent='Locate Me';}
  },function(err){
    if(btn){btn.classList.remove('ecw-locate--active');btn.querySelector('.ecw-locate__text').textContent='Location denied';}
    setTimeout(function(){if(btn)btn.querySelector('.ecw-locate__text').textContent='Locate Me';},2000);
  },{enableHighAccuracy:false,timeout:8000,maximumAge:300000});
}

function bindEvents(){
  var lb=document.getElementById('ecw-locate-btn');if(lb)lb.addEventListener('click',locateMe);

  var searchInput=document.getElementById('ecw-search');
  if(searchInput){var timer;searchInput.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(function(){searchQuery=searchInput.value;applyFilters();},200);});}
  document.querySelectorAll('.ecw-filter').forEach(function(btn){
    btn.addEventListener('click',function(){
      document.querySelectorAll('.ecw-filter').forEach(function(b){b.classList.remove('ecw-filter--active');});
      btn.classList.add('ecw-filter--active');currentFilter=btn.dataset.filter;applyFilters();
    });
  });
  var loadMore=document.getElementById('ecw-load-more-btn');
  if(loadMore)loadMore.addEventListener('click',function(){renderGrid();});
  var toggle=document.getElementById('ecw-map-toggle');
  if(toggle)toggle.addEventListener('click',function(){
    var wrap=document.querySelector('.ecw-map-wrap');
    if(wrap.style.display==='none'){wrap.style.display='block';toggle.textContent='Hide Map';if(map)map.invalidateSize();}
    else{wrap.style.display='none';toggle.textContent='Show Map';}
  });
}

function init(){
  bindEvents();waitForData(buildStores);
  var link=document.createElement('link');link.rel='stylesheet';link.href='https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';document.head.appendChild(link);
  var script=document.createElement('script');script.src='https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';script.onload=function(){initMap();};document.head.appendChild(script);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();